import React from "react";
import { Link } from "react-router-dom";
import { styles } from "../../layout";
const EquityResearchBlog: React.FC = () => {
  return (
    <div style={styles.pageContainer}>
      <h1 style={styles.header}>How I landed a job on Wall Street at 19</h1>

      <p>- Jack</p>
      <p style={styles.date}>Published on June 25, 2025</p>

      <Link to="/blogs" style={styles.backLink}>
        Back to Blogs
      </Link>
    </div>
  );
};

export default EquityResearchBlog;
